import React from 'react';
import AccommodationSearch from '../AccommodationSearch/AccommodationSearch';

function filterCampaignProducts(result) {
  return drupalSettings.campaignProductsIds.includes(result.field_product_id);
}

const AccomondationSearchCampaign = () => {
  return (
    <>
      {drupalSettings.campaignProductsIds.length !== 0 ? (
        <AccommodationSearch
          results="campaign"
          customFilter={filterCampaignProducts}
        />
      ) : (
        <h3>{Drupal.t('This campaign is not active anymore')}</h3>
      )}
    </>
  );
};

export default AccomondationSearchCampaign;
